export default {"theme":{"dark":true},"icons":{"iconfont":"mdiSvg"}}
